import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'techlify-ng';

const routes: Routes = [
];
import { HealthIssueViewAllComponent } from "./health-issue-view-all.component";
routes.push({ path: 'health/issues', component: HealthIssueViewAllComponent, canActivate: [AuthGuard] });

export const HealthIssueRoutingProvider = RouterModule.forRoot(routes, { useHash: true });